import { useTheme } from "next-themes";
import React from "react";
import { HashLoader } from "react-spinners";

const SplashLoader = () => {
  const { theme } = useTheme();
  return (
    <>
      {/* <div className="flex items-center justify-center h-screen bg-white dark:bg-dark1">
       <HashLoader size={50} color="#0F88C9" />
      
     </div> */}
      <div className="flex h-screen">
        <span className="relative flex m-auto h-14 w-14">
          <span className="animate-ZoomOut absolute left-[4%] -top-[4%] h-full inline-flex w-full rounded-full bg-primary opacity-75"></span>
          {/* image to change  */}

          <img
            src={
              theme === "dark"
                ? "/Assets/logos/logo_dark.png"
                : "/Assets/logos/logo_light.png"
            }
            alt="splashLogo"
            className="relative inline-flex"
          />
        </span>
      </div>
    </>
  );
};

export default SplashLoader;
